// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"2b2255ff","580":"1967f379"}[chunkId] + ".chunk.js";
};